import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, IconButton, Drawer, List, ListItem, ListItemText , Divider , Button} from '@mui/material';
import { Outlet } from "react-router-dom";
import { IoMdMenu } from "react-icons/io";
import { IoIosLogOut } from "react-icons/io";
import { IoMdClose } from "react-icons/io";


function MarketingLayout() {
  const drawerWidth = 240;
  const [open, setOpen] = useState(true);



  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setOpen(false);  
      } else {
        setOpen(true); 
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);




  const toggleDrawer = () => {
    setOpen(!open);
  };



  const handleLogout = ()=>{}

  return (
    <>
       <div className="flex flex-col h-screen">
            <AppBar position="static" sx={{ zIndex: 1100 }}>
                <Toolbar>
                 <IconButton edge="start" color="inherit" onClick={toggleDrawer}>
                    <IoMdMenu/>
                 </IconButton>
                  <Button color="inherit" onClick={handleLogout} style={{position:"absolute", right:"30px"}}>
                      <IoIosLogOut className='font-bold text-[25px] mr-[5px]'/>{" "}Logout
                  </Button>
               </Toolbar>
            </AppBar>
        
        <Drawer
        variant="temporary"
        open={open}
        onClose={toggleDrawer}
        sx={{
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            zIndex: 1200, 
          },
        }}
      >
       <div className="p-4 relative">
          <Typography variant="h6" className="font-bold text-center">
            Allynor
          </Typography>
          <IconButton onClick={toggleDrawer} style={{position:"absolute", right:"0", top:"0"}}>
               <IoMdClose/>
          </IconButton>
        </div>
        <Divider />
        <List className="flex flex-col" style={{marginTop:"30px"}}>
          {['Dashboard', 'Products'].map((text) => (
            <ListItem button key={text} style={{textAlign:"center", cursor:"pointer"}}>
              <ListItemText primary={text} />
            </ListItem>
          ))}
        </List>
        </Drawer>

      <main className="flex-1 p-4 overflow-auto">
         <Outlet/>
      </main>

      <footer className="bg-gray-800 text-white p-4">
        <Typography variant="body1">© 2024 Your Company</Typography>
      </footer>
       </div>
    </>
  );
}
export default MarketingLayout;
